// extracted by mini-css-extract-plugin
export default {"video-container":"FrontPage__video-container__3t1Nk","videoContainer":"FrontPage__video-container__3t1Nk","fade":"FrontPage__fade__2_bJr"};